import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { VueReCaptcha } from 'vue-recaptcha-v3'
//import './index.css'
const app = createApp(App)

app.use(store)
app.use(router)
app.use(VueReCaptcha, { siteKey: '6LfzsPAqAAAAAEz15jIeBlxYuc6HGCGjMOErVNVh', loaderOptions: { autoHideBadge: true } }) // Replace with your actual site key and desired loader options

app.mount('#app')
